export const outreachBackLinkTypeConstants = [
    { name: "Guest Post", value: "guest post", variant: "light-primary" },
    { name: "Link Insertion", value: "link insertion", variant: "light-info" },
];

export const guestPostConstants = 'guest post'
export const linkInsertionConstants = 'link insertion'